import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';
import { BoxProps } from './BoxProps';

export const Box: FunctionComponent<PropsWithChildren<BoxProps>> = ({ className, children }) => {
  return (
    <div className={classNames('box-padding bg-white rounded-lg box-border shadow-sm', className)}>{children}</div>
  );
};
